<template>
  <div id="app">
    <NotaRemisionForm @submit="handleFormSubmit" />
    <div v-if="formularioEnviado">
      <h2>Información enviada:</h2>
      <pre>{{ notaRemision }}</pre>
    </div>
  </div>
</template>

<script>
import NotaRemisionForm from "@/components/NotaRemisionForm.vue";

export default {
  components: {
    NotaRemisionForm,
  },
  data() {
    return {
      notaRemision: {},
      formularioEnviado: false,
    };
  },
  methods: {
    handleFormSubmit(data) {
      console.log(data);
      this.notaRemision = data;
      this.formularioEnviado = true;
    },
  },
};
</script>

<style>
/* Estilos globales de la aplicación, si es necesario */
</style>
